import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import Select from "react-select";
import ReactTable from "react-table-6";
import { Editor, activeEditor } from "@tinymce/tinymce-react";
import moment from "moment";
import Tabs from "./Tabs";
import Modal from "./Modal";
import Panel from "./Panel";
import ModalContent from "../ModalContent/ModalContent";
import Email from "../Email/Email";
import Blog from "../Blog/Blog";
import BlogEditor from "../Blog/BlogEditor";
import {
  listBlogs,
  getBlogContent,
  updateBlog,
  insertBlog,
  normalizeFaqsFromApi,
  faqsForApi,
} from "../Blog/blogApi";
import PostData from "../city/data/post.js";
import {
  footerHtml,
  buttonHtml,
  getHtmlElement,
  blogFooter,
} from "../city/utils/footer";
import { modalStyle, mainStyle, colourStyles } from "../city/utils/style";
import Appointments from "../Appointments/Appointments";
import BotBuilder from "../BotBuilder/botBuilder";
import "react-table-6/react-table.css";
import style from "./City.module.scss";
import BotBuilderLeftPane from "../BotBuilder/botBuilderLeftPane";
import EmailEditorContent from "../Email/EmailComponents/EmailEditorContent";
import { Link } from "react-router-dom";
import Smallcase from "../Smallcase/Smallcase";

var counter = 0;

class City extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: [],
      cityData: [],
      matchData: [],
      savedList: [],
      emailText: "",
      responseData: "",
      category: [
        "delivered",
        "new",
        "bounced",
        "open",
        "deferred",
        "click",
        "blocked",
        "invalid",
        "unsubscribe",
      ],
      subject: "",
      fromName: "Abhishek Banerjee",
      fromEmail: "investor.relations@lotusdew.in",
      buttonDescription: "",
      selectedCategoryOption: [],
      loading: false,
      error: false,
      subscriptionStatus: [
        "REQUESTED_ACCESS",
        "UNSUBSCRIBED",
        "RESUBSCRIBE_REQUESTED",
        "SUBSCRIBED",
        "GRACE_PERIOD",
      ],
      selectedSubcription: [],
      subsEnabled: false,
      testHtml: footerHtml,
      selectedTab: 1,
      toggleList: false,
      rawHtml: "",
      isModalOpen: false,
      isInnerModalOpen: false,
      typeList: ["email", "blog", "Appointments", "Bot builder"],
      selectedType: "blog",
      blogTitle: "",
      blogSubTitle: "",
      blogAuthor: "",
      blogMetaTitle: "",
      blogMetaDescription: "",
      blogKeywords: "",
      blogImgUrl: "",
      image: "",
      source: "",
      selectedRadioOption: "No",
      imageError: false,
      footerRender: blogFooter,
      imageURlErrored: false,
      scheduleList: [],
      selectedSentimentType: "Positive",
      Sentiment: [
        "Highly Positive",
        "Positive",
        "Neutral",
        "Negative",
        "Extremely Negative",
      ],
      attendedId: 0,
      comments: "",
      callStatus: "",
      savedData: [],
      imageHtml: "",
      titleAdded: false,
      EditorSet: "",
      startDate: new Date(),
      endDate: new Date(),
      formatStartDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
      formatEndDate: moment().add(7, "days").format("YYYY-MM-DD"),
      emailDraft: "",
      totalDates: {},
      fileSmallCase: [null],
      faqs: [],
      blogList: [],
      blogListLoading: false,
      blogContentLoading: false,
      blogMode: "create",
      editingBlogId: null,
      editingBlogSlug: "",
      blogSlug: "",
    };
  }

  componentDidMount() {
    const finalData = PostData.map((data) => {
      let count = Object.values(data)[0];
      return { value: { city: data.city, count: count }, label: data.city };
    });
    this.setState({ cityData: finalData });
  }

  handleChange = (selectedOption) => {
    if (selectedOption !== null) {
      const total = [...selectedOption];
      let results;
      let format;
      var concatArray = [];
      let subsEnabled;

      total.map((option) => {
        const label = option.label;
        results = PostData.filter(
          (question) =>
            question.city
              .replace(/[^a-zA-Z0-9 ]/g, "")
              .split(" ")
              .join("")
              .toLowerCase() ===
            label
              .replace(/[^a-zA-Z0-9 ]/g, "")
              .split(" ")
              .join("")
              .toLowerCase()
        );

        format = results.map((data) => {
          let count = Object.values(data)[0];
          return { city: data.city, count: count };
        });

        concatArray = concatArray.concat(format);
        return results;
      });
      const subsEnable =
        total && total.filter((data) => data.label === "smallcase-target");
      subsEnabled = subsEnable.length > 0 ? true : false;
      this.setState({
        matchData: concatArray,
        selectedOption: total,
        subsEnabled: subsEnabled,
      });
    } else {
      this.setState({
        matchData: [],
        selectedOption: [],
        selectedSubcription: [],
        subsEnabled: false,
      });
    }
  };

  handleCategoryChange = (selectedCategoryOption) => {
    if (selectedCategoryOption !== null) {
      const total = [...selectedCategoryOption];
      this.setState({ selectedCategoryOption: total });
    } else {
      this.setState({ selectedCategoryOption: [] });
    }
  };

  handleSubscriptionChange = (selectedSubcription) => {
    if (selectedSubcription !== null) {
      const total = [...selectedSubcription];
      this.setState({ selectedSubcription: total });
    } else {
      this.setState({ selectedSubcription: [] });
    }
  };

  handleSourceChange = (selectedCase) => {
    this.setState({ source: selectedCase }, () => {
      if (selectedCase) {
        this.fetchBlogList(selectedCase);
      } else {
        this.setState({ blogList: [] });
      }
    });
  };

  fetchBlogList = (sourceOverride) => {
    const source = sourceOverride || this.state.source;
    if (!source) return;

    this.setState({ blogListLoading: true });
    listBlogs(source)
      .then((blogs) => {
        this.setState({
          blogList: blogs,
          blogListLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          blogListLoading: false,
          blogList: [],
          error: true,
          responseData: error.message || "Failed to load blogs",
        });
        this.openModal();
      });
  };

  resetBlogForm = () => {
    this.setState({
      blogMode: "create",
      editingBlogId: null,
      editingBlogSlug: "",
      blogSlug: "",
      blogTitle: "",
      blogSubTitle: "",
      blogAuthor: "",
      blogMetaTitle: "",
      blogMetaDescription: "",
      blogKeywords: "",
      blogImgUrl: "",
      image: "",
      selectedRadioOption: "No",
      faqs: [],
      emailText: "",
      rawHtml: "",
      footerRender: blogFooter,
      titleAdded: false,
    });
  };

  openBlogForEdit = (blog) => {
    const { source } = this.state;
    if (!source || !blog) return;

    this.setState({ blogContentLoading: true });
    getBlogContent({
      source,
      slug: blog.slug,
      title: blog.title,
    })
      .then((data) => {
        const content = data.content || "";
        const coverUrl = blog.url || data.url || "";
        this.setState({
          blogMode: "edit",
          editingBlogId: blog.id != null ? blog.id : null,
          editingBlogSlug: data.slug || blog.slug || "",
          blogSlug: data.slug || blog.slug || "",
          blogTitle: data.title || blog.title || "",
          blogSubTitle: data.subtitle || data.sub_title || blog.sub_title || "",
          blogAuthor: blog.author || "",
          blogMetaTitle: data.meta_title || blog.meta_title || "",
          blogMetaDescription:
            data.meta_description || blog.meta_description || "",
          blogKeywords: data.keywords || blog.keywords || "",
          blogImgUrl: coverUrl,
          image: coverUrl,
          selectedRadioOption: coverUrl ? "Yes" : "No",
          faqs: normalizeFaqsFromApi(data.faqs || blog.faqs),
          emailText: content,
          rawHtml: content,
          footerRender: content || blogFooter,
          titleAdded: true,
          blogContentLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          blogContentLoading: false,
          error: true,
          responseData: error.message || "Failed to open blog",
        });
        this.openModal();
      });
  };

  handleTextChange = (e, type) => {
    switch (type) {
      case "subject":
        this.setState({
          subject: e.target.value,
        });
        break;
      case "from-name":
        this.setState({
          fromName: e.target.value,
        });
        break;
      case "from-email":
        this.setState({
          fromEmail: e.target.value,
        });
        break;
      default:
        console.log("unknown category");
        break;
    }
  };

  handleBlogTextChange = (e, type) => {
    let re =
      /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    switch (type) {
      case "title":
        this.setState({
          blogTitle: e.target.value,
          titleAdded: true,
        });
        break;
      case "sub_title":
        this.setState({
          blogSubTitle: e.target.value,
        });
        break;
      case "author":
        this.setState({
          blogAuthor: e.target.value,
        });
        break;
      case "meta_title":
        this.setState({
          blogMetaTitle: e.target.value,
        });
        break;
      case "meta_description":
        this.setState({
          blogMetaDescription: e.target.value,
        });
        break;
      case "keywords":
        this.setState({
          blogKeywords: e.target.value,
        });
        break;
      case "slug":
        this.setState({
          blogSlug: e.target.value,
        });
        break;
      case "url":
        const isValidURL = re.test(e.target.value);
        this.setState({
          blogImgUrl: e.target.value,
          imageURlErrored: !isValidURL,
        });
        break;
      default:
        console.log("unknown category");
        break;
    }
  };

  handleAddFaq = () => {
    this.setState((prevState) => ({
      faqs: [...(prevState.faqs || []), { question: "", answer: "" }],
    }));
  };

  handleRemoveFaq = (index) => {
    this.setState((prevState) => ({
      faqs: (prevState.faqs || []).filter((_, i) => i !== index),
    }));
  };

  handleFaqChange = (index, field, value) => {
    this.setState((prevState) => {
      const updatedFaqs = [...(prevState.faqs || [])];
      if (updatedFaqs[index]) {
        updatedFaqs[index] = { ...updatedFaqs[index], [field]: value };
      }
      return { faqs: updatedFaqs };
    });
  };

  onSaveBlog = () => {
    const {
      toggleList,
      rawHtml,
      footerRender,
      image,
      blogTitle,
      blogSubTitle,
      blogAuthor,
      blogMetaTitle,
      blogMetaDescription,
      blogKeywords,
      blogImgUrl,
      selectedRadioOption,
      source,
      faqs,
      blogMode,
      editingBlogId,
      editingBlogSlug,
      blogSlug,
    } = this.state;
    const htmlString = toggleList ? rawHtml : footerRender;
    const format = moment().format("MMM DD, YYYY");
    const url = selectedRadioOption === "Yes" ? blogImgUrl : image;
    const faqPayload = faqsForApi(faqs);

    this.setState({ loading: true });

    const finish = (response, options = {}) => {
      this.setState({
        responseData: (response && response.message) || "Saved successfully",
        loading: false,
        error: false,
        ...(options.resetForm
          ? {
              blogMode: "create",
              editingBlogId: null,
              editingBlogSlug: "",
            }
          : {}),
      });
      this.openModal();
      this.fetchBlogList(source);
    };

    const fail = (error) => {
      this.setState({
        loading: false,
        error: true,
        responseData: error.message || "Save failed",
      });
      this.openModal();
    };

    if (blogMode === "edit" && (editingBlogId != null || editingBlogSlug || blogTitle)) {
      const payload = {
        sub_title: blogSubTitle,
        updated_on: format,
        author: blogAuthor,
        content: htmlString,
        url: url,
        source: source,
        meta_title: blogMetaTitle,
        meta_description: blogMetaDescription,
        keywords: blogKeywords,
        faqs: faqPayload,
      };

      if (editingBlogId != null) {
        payload.id = editingBlogId;
        payload.title = blogTitle;
        if (blogSlug) payload.slug = blogSlug;
      } else if (editingBlogSlug) {
        payload.slug = editingBlogSlug;
        payload.title = blogTitle;
        if (blogSlug && blogSlug !== editingBlogSlug) {
          payload.new_slug = blogSlug;
        }
      } else {
        payload.title = blogTitle;
      }

      updateBlog(payload).then((response) => finish(response)).catch(fail);
      return;
    }

    const createPayload = {
      title: blogTitle,
      updated_on: format,
      sub_title: blogSubTitle,
      author: blogAuthor,
      content: htmlString,
      url: url,
      source: source,
      meta_title: blogMetaTitle,
      meta_description: blogMetaDescription,
      keywords: blogKeywords,
      faqs: faqPayload,
    };

    insertBlog(createPayload)
      .then((response) => finish(response, { resetForm: true }))
      .catch(fail);
  };

  handleFileSmallCase = (selectedOption) => {
    // console.log(selectedOption,"selectedOption in city")
    const selected = [selectedOption.value];
    // console.log(selected,"selected")
    this.setState({
      fileSmallCase: selected,
    });
  };

  onSave = () => {
    const {
      selectedOption,
      fromName,
      subject,
      toggleList,
      rawHtml,
      testHtml,
      selectedCategoryOption,
      selectedSubcription,
      fromEmail,
      emailText,
      domainName,
      fileSmallCase,
    } = this.state;
    console.log(fileSmallCase, "fileSmallCase in city");
    let finalMatch = selectedOption.map((data) => {
      return data.label;
    });

    const categoryMatch = selectedCategoryOption.map((data) => {
      return data.label;
    });
    const SubsMatch = selectedSubcription
      ? selectedSubcription.map((data) => data.label)
      : [];
    let finalHtml = testHtml;
    // if(testHtml === '' && emailText !== ''){
    console.log(emailText, "emailText");
    finalHtml = getHtmlElement(emailText, footerHtml);
    // }
    const htmlString = toggleList ? rawHtml : finalHtml;
    console.log(htmlString, "htmlString");
    const totalData = {
      subject: subject,
      subscription_status: SubsMatch,
      sender_name: fromName,
      sender_email: fromEmail,
      category: categoryMatch,
      cities: finalMatch,
      html_string: htmlString,
      smallcase_name: fileSmallCase,
    };
    this.setState({ loading: true });

    //console.log("fromEmail:",fromEmail)

    let email = fromEmail;
    let name = email.substring(0, email.lastIndexOf("@"));
    //console.log("email:",email)
    let domain = email.substring(email.lastIndexOf("@") + 1);
    // console.log("domain:",domain)

    let requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(totalData),
    };
    // console.log(totalData,"totalData")
    // console.log(requestOptions,"requestOptions")
    const val = domain !== "lotusdew.in" ? domain : "chat-crm." + domain;
    fetch(`https://${val}/sendBulkEmails`, requestOptions)
      .then((res) => res.json())
      .then((response) => {
        this.setState({
          responseData: response.message,
          loading: false,
          error: false,
        });
        this.openModal();
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: true,
          responseData: error.message,
        });
        this.openModal();
      });
  };

  saveTextEditorContent = (content) => {
    const totalData = {
      html_string: content,
    };

    localStorage.setItem("emailDraft", JSON.stringify(totalData));
  };

  onChange = (content, type) => {
    const { selectedType } = this.state;

    switch (type) {
      case "main-editor":
        if (selectedType === "email") {
          this.saveTextEditorContent(content);
          this.setState({
            emailText: content,
            testHtml: getHtmlElement(content, footerHtml),
            footerRender: getHtmlElement(content, footerHtml),
            EditorSet: content,
          });
        } else {
          this.setState({
            emailText: content,
            footerRender: content,
            EditorSet: content,
          });
        }

        break;
      default:
        console.log("unknown category");
        break;
    }
  };

  //   onChange = (e,type) => {
  //     const { selectedType } = this.state;

  //     console.log(e.target.value,"e.target.value")
  //     switch (type) {
  //         case "main-editor":
  //             if(selectedType === 'email'){
  //             this.saveTextEditorContent(e.target.getContent());
  //               this.setState({
  //                 emailText:   e.target.value,
  //                 testHtml: getHtmlElement(e.target.getContent(), footerHtml),
  //                 footerRender:getHtmlElement(e.target.getContent(), footerHtml),
  //                 EditorSet:e.target,
  //                 //  emailText:  e,
  //                 // testHtml: getHtmlElement(e, footerHtml),
  //                 // footerRender:getHtmlElement(e, footerHtml),
  //                 // EditorSet:e,
  //               });
  //             }
  //             else{
  //               this.setState({
  //                 emailText:  e.target.value,
  //                 footerRender: e.target.getContent(),
  //                 EditorSet:e.target,
  //                 // emailText:    e,
  //                 // footerRender: e,
  //                 // EditorSet:e.target,
  //               });
  //             }

  //           break;
  //         default:
  //           console.log("unknown category");
  //           break;
  //       };

  //   }

  onConfirm = () => {
    this.props.history.push("/");
  };

  onToggle = () => {
    const { toggleList } = this.state;
    this.setState({ toggleList: !toggleList });
  };

  onChangeRawHtMl = (e) => {
    this.setState({ rawHtml: e.target.value });
  };

  closeModal = () => {
    const { responseData, selectedType, error } = this.state;
    this.setState({
      isModalOpen: false,
      responseData: "",
      savedData: "",
    });
    if (selectedType === "Appointments") {
      // responseData !== ''  &&  this.props.history.push("/");
    } else if (selectedType === "email" && error === true) {
      console.log("failed to send email.");
    } else {
      //this.props.history.push("/");
    }
  };

  openModal = () => {
    this.setState({
      isModalOpen: true,
    });
  };

  getTextEditorContent = () => {
    const draftExists = localStorage.getItem("emailDraft") !== null;
    if (draftExists) {
      const emailContent = localStorage.getItem("emailDraft");
      const finalContent = JSON.parse(emailContent);
      this.setState({
        emailText: finalContent.html_string,
        footerRender: getHtmlElement(finalContent.html_string, footerHtml),
      });
    } else {
      this.setState({ footerRender: footerHtml });
    }
  };

  handleChangeTypes = (selectedOption) => {
    const { formatStartDate } = this.state;
    if (selectedOption.value === "email") {
      this.getTextEditorContent();
    } else if (selectedOption.value === "Appointments") {
      const startDate = new Date();
      const endDate = moment(startDate, "YYYY-MM-DD").add(7, "days");
      this.onSubmitDate(formatStartDate, endDate);
    } else {
      this.setState({ footerRender: blogFooter });
    }
    this.setState({ selectedType: selectedOption.value });
  };

  onUpload = (e) => {
    //  var url = URL.createObjectURL(e.target.files[0]);
    const { blogTitle } = this.state;
    // if(blogTitle !== ''){
    const title = blogTitle.split(" ").join("-");
    var self = this;
    var reader = new FileReader();
    var file = e.target.files[0];
    var sFileName = file.name;
    var sFileExtension = sFileName.split(".")[1].toUpperCase();
    var iFileSize = file.size / 1024 / 1024;
    if (
      (sFileExtension === "PNG" ||
        sFileExtension === "JPEG" ||
        sFileExtension === "JPG") &&
      iFileSize < 3
    ) {
      reader.onload = function (upload) {
        const totalData = {
          title: title,
          image: upload.target.result,
        };
        const jsonFormat = JSON.stringify(totalData);
        self.getImageUrl("blog-img", jsonFormat);
      };
    } else {
      reader.onload = function (upload) {
        self.setState({
          image: "",
          imageError: true,
        });
      };
    }

    reader.readAsDataURL(file);
    //   }
    //   else{
    //     this.setState({titleAdded: false})
    //  }
  };

  getImageUrl = (type, jsonFormat) => {
    this.setState({ loading: true });
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonFormat,
    };
    fetch(
      "https://m73hh8wqb2.execute-api.ap-south-1.amazonaws.com/upload_blog",
      requestOptions
    )
      .then((res) => res.json())
      .then((response) => {
        if (type === "content") {
          const images = `<img src=${response.url} alt="img" width="500px" height="300px" />`;
          this.setState({
            responseData: response.url,
            imageHtml: images,
            emailText:
              this.state.EditorSet !== ""
                ? this.state.EditorSet.setContent(images + this.state.emailText)
                : images + this.state.emailText,
            footerRender: images + this.state.footerRender + blogFooter,
            imageError: false,
            loading: false,
            error: false,
          });
        } else {
          this.setState({
            image: response.url,
            imageError: false,
            loading: false,
            error: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: true,
          responseData: error.message,
        });
      });
  };

  onUploadMultiImages = (e) => {
    const { blogTitle } = this.state;
    const title = blogTitle.split(" ").join("-");
    this.setState({ titleAdded: true });

    const files = Array.from(e.target.files); // multiple files support

    files.forEach((file) => {
      const sFileName = file.name;
      const sFileExtension = sFileName.split(".").pop().toUpperCase();
      const iFileSize = file.size / 1024 / 1024;

      if (["PNG", "JPEG", "JPG"].includes(sFileExtension)) {
        const reader = new FileReader();

        reader.onload = (upload) => {
          const totalData = { image: upload.target.result };
          const jsonFormat = JSON.stringify(totalData);
          this.getImageUrl("content", jsonFormat);
        };

        reader.readAsDataURL(file);
      } else {
        this.setState({
          image: "",
          imageError: true,
          imageHtml: "",
        });
      }
    });
  };

  radioChange = (e) => {
    this.setState({
      selectedRadioOption: e.currentTarget.value,
    });
  };

  onError = () => {
    const { imageURlErrored, blogImgUrl } = this.state;
    if (!imageURlErrored && blogImgUrl !== "") {
      this.setState({
        imageURlErrored: true,
        blogImgUrl: "",
      });
    } else if (imageURlErrored) {
      this.setState({
        imageURlErrored: true,
      });
    }
  };

  onSubmitDate = (startDate, EndDate) => {
    const totalData = {
      fromDate: moment(startDate).format("YYYY-MM-DD"),
      toDate: moment(EndDate).format("YYYY-MM-DD"),
    };
    const jsonFormat = JSON.stringify(totalData);
    this.setState({ loading: true });

    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonFormat,
    };

    fetch("https://api.lotusdew.in/api/schedule-list", requestOptions)
      .then((res) => res.json())
      .then((response) => {
        this.setState({
          scheduleList: response.data,
          loading: false,
          error: false,
          totalDates: { startDate: startDate, EndDate: EndDate },
        });
      })
      .catch((error) => {
        this.setState({ loading: false, error: true, scheduleList: "" });
      });
  };

  onsaveFeedback = () => {
    const {
      attendedId,
      comments,
      selectedSentimentType,
      totalDates,
      formatStartDate,
    } = this.state;

    const totalData = {
      call_status: "Completed",
      comments: comments,
      sentiment: selectedSentimentType,
      id: attendedId.toString(),
    };
    const condition =
      Object.keys(totalDates).length === 0 && totalDates.constructor === Object;
    const jsonFormat = JSON.stringify(totalData);
    this.setState({ loading: true, responseData: "" });

    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonFormat,
    };

    fetch("https://api.lotusdew.in/api/schedule-update", requestOptions)
      .then((res) => res.json())
      .then((response) => {
        if (condition) {
          const startDate = new Date();
          const endDate = moment(startDate, "YYYY-MM-DD").add(7, "days");
          this.onSubmitDate(formatStartDate, endDate);
        } else {
          this.onSubmitDate(totalDates.startDate, totalDates.EndDate);
        }
        this.setState({ responseData: response.message });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: true,
          responseData: error.message,
        });
      });
  };

  onAttend = (row) => {
    if (row.original.call_status === "Completed") {
      const totalData = {
        id: row.original.id.toString(),
      };

      const jsonFormat = JSON.stringify(totalData);
      this.setState({ loading: true, responseData: "" });

      let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: jsonFormat,
      };

      fetch("https://api.lotusdew.in/api/schedule-get", requestOptions)
        .then((res) => res.json())
        .then((response) => {
          this.setState({
            savedData: response.data,
            loading: false,
            error: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            error: true,
            savedData: error.message,
          });
        });
    }
    this.openModal();
    this.setState({
      attendedId: row.original.id,
      callStatus: row.original.call_status,
    });
  };

  handleChangeSentiment = (selectedOption) => {
    this.setState({ selectedSentimentType: selectedOption.value });
  };

  onComment = (e) => {
    this.setState({ comments: e.target.value });
  };

  handleAppointmentChange = (date) => {
    this.setState({
      formatStartDate: moment(date).format("DD/MM/YYYY"),
      startDate: date,
      formatEndDate: moment(date).format("DD/MM/YYYY"),
      endDate: date,
    });
  };
  handleEndDate = (date) => {
    this.setState({
      formatEndDate: moment(date).format("DD/MM/YYYY"),
      endDate: date,
    });
  };

  render() {
    const {
      selectedOption,
      selectedRadioOption,
      imageURlErrored,
      footerRender,
      rawHtml,
      image,
      selectedType,
      typeList,
      emailText,
      toggleList,
      cityData,
      matchData,
      loading,
      responseData,
      subject,
      titleAdded,
      fromName,
      fromEmail,
      selectedSentimentType,
      subscriptionStatus,
      selectedCategoryOption,
      category,
      scheduleList,
      Sentiment,
      selectedSubcription,
      subsEnabled,
      savedData,
      comments,
      imageError,
      blogTitle,
      blogSubTitle,
      blogAuthor,
      blogMetaTitle,
      blogMetaDescription,
      blogKeywords,
      blogSlug,
      blogImgUrl,
      emailDraft,
      source,
      startDate,
      endDate,
      formatEndDate,
      formatStartDate,
      callStatus,
      attendedId,
      blogList,
      blogListLoading,
      blogContentLoading,
      blogMode,
      editingBlogId,
    } = this.state;
    const types = typeList.map((list) => {
      return { value: list, label: list };
    });
    const feedbackTypes = Sentiment.map((list) => {
      return { value: list, label: list };
    });
    const EditorName =
      selectedType === "email" ? "Email Content" : "Blog Content";
    // if(this.props.location.authSuccess === false || this.props.location.authSuccess === undefined ) {
    //    return <Redirect to='/'  />
    // }
    //  console.log(selectedOption,"selectedOption")
    let sum = 0;
    if (matchData.length > 0) {
      matchData.map((data) => {
        let add = Object.values(data)[1];
        sum = sum + add;
        return sum;
      });
    }
    const categoryList = category.map((data) => {
      return { value: data, label: data };
    });
    const SubscriptionList = subscriptionStatus.map((data) => {
      return { value: data, label: data };
    });
    const htmlString = toggleList ? rawHtml : emailText;
    const blogCondition =
      !blogTitle ||
      !blogSubTitle ||
      !blogAuthor ||
      (!image && !blogImgUrl) ||
      !htmlString ||
      !source;
    const condition =
      matchData.length === 0 ||
      !fromName ||
      !subject ||
      (subsEnabled && selectedSubcription.length === 0) ||
      selectedCategoryOption.length === 0 ||
      !fromEmail ||
      (!rawHtml && !emailText);
    const columns = [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: (row) => <span>{moment(row.value).format("DD MMM, YYYY")}</span>,
      },
      {
        Header: "Slot",
        accessor: "slot",
      },
      {
        Header: "Created At",
        accessor: "created_at",
        Cell: (row) => <span>{moment(row.value).format("DD MMM, YYYY")}</span>,
      },
      {
        Header: "Call Status",
        accessor: "call_status",
        Cell: (row) => (
          <div className="callStatus-container">
            {/* {row.value} */}
            {row.value !== "Completed" ? (
              <button className="attended-btn">
                <i
                  class="fa fa-calendar"
                  aria-hidden="true"
                  onClick={() => this.onAttend(row)}
                >
                  &nbsp;Attended
                </i>
              </button>
            ) : (
              <button className="attended-btn">
                <i
                  class="fa fa-calendar-check-o"
                  aria-hidden="true"
                  onClick={() => this.onAttend(row)}
                >
                  &nbsp;Completed
                </i>
              </button>
            )}
          </div>
        ),
      },
    ];
    return (
      <div>
        <Smallcase />

        <section className="mail-body">
          <Modal
            isModalOpen={this.state.isModalOpen}
            closeModal={this.closeModal}
            style={modalStyle}
          >
            <ModalContent
              selectedType={selectedType}
              scheduleList={scheduleList}
              responseData={responseData}
              feedbackTypes={feedbackTypes}
              handleChangeSentiment={this.handleChangeSentiment}
              callStatus={callStatus}
              savedData={savedData}
              selectedSentimentType={selectedSentimentType}
              comments={comments}
              onComment={(e) => this.onComment(e)}
              mainStyle={mainStyle}
              closeModal={this.closeModal}
              onsaveFeedback={this.onsaveFeedback}
            />
          </Modal>
          {loading && (
            <div>
              <div className={style.appOverlay} />
              <div className={style.loader} />
            </div>
          )}
          <section className={style.mailContainer}>
            <section className={style.selectDropdown}>
              <Select
                defaultValue={types[1]}
                className={style.selectType}
                onChange={this.handleChangeTypes}
                options={types}
                styles={colourStyles}
              />
              {selectedType === "email" && (
                <Email
                  selectedOption={selectedOption}
                  handleChange={this.handleChange}
                  cityData={cityData}
                  colourStyles={colourStyles}
                  selectedCategoryOption={selectedCategoryOption}
                  handleCategoryChange={this.handleCategoryChange}
                  categoryList={categoryList}
                  selectedSubcription={selectedSubcription}
                  subsEnabled={subsEnabled}
                  handleSubscriptionChange={this.handleSubscriptionChange}
                  SubscriptionList={SubscriptionList}
                  handleTextChange={this.handleTextChange}
                  onSave={this.onSave}
                  condition={condition}
                  fromEmail={fromEmail}
                  fromName={fromName}
                  handleFileSmallCase={this.handleFileSmallCase}
                />
              )}
              {selectedType === "blog" && (
                <Blog
                  handleBlogTextChange={this.handleBlogTextChange}
                  selectedRadioOption={selectedRadioOption}
                  titleAdded={titleAdded}
                  radioChange={this.radioChange}
                  onUpload={this.onUpload}
                  onUploadMultiImages={this.onUploadMultiImages}
                  blogImgUrl={blogImgUrl}
                  image={image}
                  blogTitle={blogTitle}
                  blogSubTitle={blogSubTitle}
                  blogAuthor={blogAuthor}
                  blogMetaTitle={blogMetaTitle}
                  blogMetaDescription={blogMetaDescription}
                  blogKeywords={blogKeywords}
                  blogSlug={blogSlug}
                  source={source}
                  hasContent={Boolean(htmlString)}
                  onSourceChange={this.handleSourceChange}
                  onError={this.onError}
                  onSaveBlog={this.onSaveBlog}
                  imageURlErrored={imageURlErrored}
                  imageError={imageError}
                  blogCondition={blogCondition}
                  faqs={this.state.faqs}
                  onAddFaq={this.handleAddFaq}
                  onRemoveFaq={this.handleRemoveFaq}
                  onFaqChange={this.handleFaqChange}
                  blogList={blogList}
                  blogListLoading={blogListLoading}
                  blogContentLoading={blogContentLoading}
                  blogMode={blogMode}
                  editingBlogId={editingBlogId}
                  onOpenBlog={this.openBlogForEdit}
                  onNewBlog={this.resetBlogForm}
                  onRefreshBlogList={() => this.fetchBlogList()}
                />
              )}
              {selectedType === "Appointments" && (
                <Appointments
                  handleChange={this.handleAppointmentChange}
                  handleEndDate={this.handleEndDate}
                  onSubmitDate={this.onSubmitDate}
                  startDate={startDate}
                  endDate={endDate}
                  formatStartDate={formatStartDate}
                  formatEndDate={formatEndDate}
                />
              )}
              {selectedType === "Bot builder" && <BotBuilderLeftPane />}
            </section>
            <section className={style.mainEditor}>
              {selectedType === "Appointments" && (
                <div>
                  {scheduleList.length > 0 ? (
                    <div className={style.tableContainer}>
                      <ReactTable
                        data={scheduleList}
                        columns={columns}
                        // noDataText="No Data Available"
                        // filterable
                        // getTrProps={this.onRowClick}
                        defaultPageSize={5}
                        className="-striped -highlight"
                      />
                    </div>
                  ) : (
                    <div className={style.notFound}>
                      No Appointments were Scheduled
                    </div>
                  )}
                </div>
              )}
              {selectedType === "Bot builder" && <BotBuilder />}
              {selectedType === "blog" && (
                <BlogEditor
                  toggleList={toggleList}
                  onToggle={this.onToggle}
                  onChangeRawHtMl={this.onChangeRawHtMl}
                  emailText={emailText}
                  onChange={this.onChange}
                  buttonHtml={buttonHtml}
                  rawHtml={rawHtml}
                  footerRender={footerRender}
                />
              )}
              {selectedType === "email" && (
                <Tabs selected={0}>
                  <Panel title={EditorName}>
                    <EmailEditorContent
                      toggleList={toggleList}
                      selectedType={selectedType}
                      onToggle={this.onToggle}
                      onChangeRawHtMl={this.onChangeRawHtMl}
                      emailText={emailText}
                      onChange={this.onChange}
                      buttonHtml={buttonHtml}
                      rawHtml={rawHtml}
                    />
                  </Panel>
                  <Panel title="Preview">
                    <iframe title="preview" srcDoc={footerRender}></iframe>
                  </Panel>
                </Tabs>
              )}
            </section>
          </section>
        </section>
      </div>
    );
  }
}

export default withRouter(City);
